module.exports = __webpack_public_path__ + "img/nosotros_16-9_960.83d091bc.webp";